export enum IdsStepsAppointmentWizardModel {
    FAMILIES,
    PROFESSIONALS = 10,
    DATETIME = 20,
    SOCIAL_LOGIN,
    REGISTER,
    CONFIRM,
    PAYMETHODS,
    PAYMENT,
    RESULT,
}
